webpackJsonp([0],{

/***/ 730:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogPage_vue__ = __webpack_require__(733);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a506f7b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogPage_vue__ = __webpack_require__(738);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a506f7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a506f7b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_firestore__ = __webpack_require__(74);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Helper: debounce بسيط
function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 350;

  var t = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(t);t = setTimeout(function () {
      return fn.apply(undefined, args);
    }, wait);
  };
}

// إدارة مسودة الطلب الجديد (localStorage)
var DRAFT_KEY = 'newOrderDraft';
function readDraft() {
  try {
    return JSON.parse(localStorage.getItem(DRAFT_KEY) || '{"selectedProducts":[]}');
  } catch (e) {
    return { selectedProducts: [] };
  }
}
function writeDraft(d) {
  localStorage.setItem(DRAFT_KEY, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(d));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CatalogPage',
  data: function data() {
    return {
      slug: this.$route.params.slug,
      pageTitle: 'كتالوج',
      pageReady: false,
      search: '',
      sort: { by: 'createdAt', dir: 'desc' },
      filters: { categories: [], tags: [], inStockOnly: false },
      products: [],
      pageSize: 24,
      lastDoc: null,
      hasMore: true,
      loading: false,
      selectedVar: {},
      fallbackImg: 'https://via.placeholder.com/400x300?text=Product',
      debouncedReload: null,

      // existing order modal
      existingModal: false,
      existingOrderNumber: null,
      existingQty: 1,
      existingProductCtx: null,
      existingError: ''
    };
  },

  computed: {
    totalCountShown: function totalCountShown() {
      return this.products.length;
    },
    activeFiltersText: function activeFiltersText() {
      var parts = [];
      if (this.filters && this.filters.categories && this.filters.categories.length) parts.push('\u062A\u0635\u0646\u064A\u0641\u0627\u062A: ' + this.filters.categories.join(', '));
      if (this.filters && this.filters.tags && this.filters.tags.length) parts.push('\u0648\u0633\u0648\u0645: ' + this.filters.tags.join(', '));
      if (this.filters && this.filters.inStockOnly) parts.push('متوفر بالمخزون فقط');
      return parts.join(' • ');
    }
  },
  created: function created() {
    var _this = this;

    this.debouncedReload = debounce(this.reload, 350);
    this.loadPageConfig().then(function () {
      return _this.reload();
    });
  },

  watch: {
    '$route.params.slug': {
      handler: function handler() {
        var _this2 = this;

        this.slug = this.$route.params.slug;
        this.pageReady = false;
        this.products = [];
        this.lastDoc = null;
        this.hasMore = true;
        this.loadPageConfig().then(function () {
          return _this2.reload();
        });
      },
      immediate: false
    }
  },
  methods: {
    loadPageConfig: function loadPageConfig() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var db, snap, doc, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                db = __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore();
                _context.next = 3;
                return db.collection('catalog_pages').where('slug', '==', _this3.slug).limit(1).get();

              case 3:
                snap = _context.sent;

                if (!snap.empty) {
                  _context.next = 10;
                  break;
                }

                _this3.pageTitle = 'كتالوج';
                _this3.filters = { categories: [], tags: [], inStockOnly: false };
                _this3.sort = { by: 'createdAt', dir: 'desc' };
                _this3.pageReady = true;
                return _context.abrupt('return');

              case 10:
                doc = snap.docs[0];
                data = doc.data();

                _this3.pageTitle = data.title || 'كتالوج';
                _this3.filters = data.filters || { categories: [], tags: [], inStockOnly: false };
                _this3.sort = data.sort || { by: 'createdAt', dir: 'desc' };
                _this3.pageReady = true;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    buildQuery: function buildQuery(baseLimit) {
      var db = __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore();
      var q = db.collection('Products');

      // فلترة ديناميكية
      if (this.filters && this.filters.categories && this.filters.categories.length) {
        q = q.where('category', 'in', this.filters.categories.slice(0, 10));
      }
      if (this.filters && this.filters.inStockOnly) {
        q = q.where('inStock', '==', true);
      }

      // بحث بالاسم
      if (this.search) {
        // prefix search بسيط بالاسم (يتطلب فهرسة name_lower)
        var term = this.search.trim().toLowerCase();
        q = q.where('name_lower', '>=', term).where('name_lower', '<=', term + '\uF8FF');
      }

      // ترتيب
      var by = this.sort.by || 'createdAt';
      var dir = this.sort.dir === 'asc' ? 'asc' : 'desc';
      q = q.orderBy(by, dir);

      if (baseLimit) q = q.limit(baseLimit);
      if (this.lastDoc) q = q.startAfter(this.lastDoc);
      return q;
    },
    reload: function reload() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var snap;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.loading = true;
                _this4.products = [];
                _this4.lastDoc = null;
                _this4.hasMore = true;
                _context2.next = 6;
                return _this4.buildQuery(_this4.pageSize).get();

              case 6:
                snap = _context2.sent;

                _this4.products = snap.docs.map(function (d) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: d.id }, d.data());
                });
                _this4.lastDoc = snap.docs[snap.docs.length - 1] || null;
                _this4.hasMore = !!_this4.lastDoc && snap.docs.length === _this4.pageSize;
                _this4.loading = false;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    loadMore: function loadMore() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _products;

        var snap;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this5.hasMore || _this5.loading)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _this5.loading = true;
                _context3.next = 5;
                return _this5.buildQuery(_this5.pageSize).get();

              case 5:
                snap = _context3.sent;

                (_products = _this5.products).push.apply(_products, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(snap.docs.map(function (d) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: d.id }, d.data());
                })));
                _this5.lastDoc = snap.docs[snap.docs.length - 1] || null;
                _this5.hasMore = !!_this5.lastDoc && snap.docs.length === _this5.pageSize;
                _this5.loading = false;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    priceWithVar: function priceWithVar(p) {
      var vid = this.selectedVar[p.id];
      if (!vid || !p.variations || !p.variations.length) return Number(p.price || 0);
      var v = p.variations.find(function (x) {
        return x.id === vid;
      });
      var delta = v && v.priceDelta ? Number(v.priceDelta) : 0;
      return Number(p.price || 0) + delta;
    },
    addToNewOrder: function addToNewOrder(p) {
      var draft = readDraft();
      var vid = this.selectedVar[p.id] || null;
      var foundVar = vid && p.variations ? p.variations.find(function (x) {
        return x.id === vid;
      }) : null;
      var vName = foundVar ? foundVar.name : '';
      var unitPrice = this.priceWithVar(p);

      // إذا المنتج موجود بنفس المتغير -> زد الكمية
      var idx = draft.selectedProducts.findIndex(function (it) {
        return it.productId === p.id && it.variationId === vid;
      });
      if (idx > -1) {
        draft.selectedProducts[idx].quantity += 1;
      } else {
        draft.selectedProducts.push({
          productId: p.id,
          name: p.name,
          unitPrice: unitPrice,
          quantity: 1,
          imageUrl: p.imageUrl || '',
          variationId: vid,
          variationName: vName
        });
      }
      writeDraft(draft);
      this.$toast && this.$toast.success('تمت الإضافة لمسودة طلبية جديدة');
    },
    openExistingModal: function openExistingModal(p) {
      this.existingProductCtx = p;
      this.existingQty = 1;
      this.existingOrderNumber = null;
      this.existingError = '';
      this.existingModal = true;
    },
    confirmAddToExisting: function confirmAddToExisting() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var db, p, vid, foundVar, vName, unitPrice, qty, q, orderRef;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.existingError = '';

                if (!(!_this6.existingOrderNumber || !_this6.existingProductCtx)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt('return');

              case 3:
                db = __WEBPACK_IMPORTED_MODULE_5_firebase_app__["a" /* default */].firestore();
                p = _this6.existingProductCtx;
                vid = _this6.selectedVar[p.id] || null;
                foundVar = vid && p.variations ? p.variations.find(function (x) {
                  return x.id === vid;
                }) : null;
                vName = foundVar && foundVar.name ? foundVar.name : '';
                unitPrice = _this6.priceWithVar(p);
                qty = Math.max(1, Number(_this6.existingQty || 1));

                console.log('DEBUG →', { p: p, unitPrice: unitPrice, qty: qty });

                // تأكد من عدم وجود قيم undefined

                if (!(!p.id || !p.Name || unitPrice === undefined || isNaN(unitPrice) || !qty)) {
                  _context5.next = 14;
                  break;
                }

                _this6.existingError = 'بيانات المنتج غير كاملة أو غير صحيحة.';
                return _context5.abrupt('return');

              case 14:
                _context5.prev = 14;
                _context5.next = 17;
                return db.collection('orders').where('orderNumber', '==', Number(_this6.existingOrderNumber)).limit(1).get();

              case 17:
                q = _context5.sent;

                if (!q.empty) {
                  _context5.next = 21;
                  break;
                }

                _this6.existingError = 'لم يتم العثور على طلبية بهذا الرقم';
                return _context5.abrupt('return');

              case 21:
                orderRef = q.docs[0].ref;
                _context5.next = 24;
                return db.runTransaction(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(tx) {
                    var snap, data, list, i;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return tx.get(orderRef);

                          case 2:
                            snap = _context4.sent;

                            if (snap.exists) {
                              _context4.next = 5;
                              break;
                            }

                            throw new Error('Order not found');

                          case 5:
                            data = snap.data() || {};
                            list = data.cart ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.cart)) : [];
                            i = list.findIndex(function (it) {
                              return it.productId === p.id && it.variationId === vid;
                            });

                            if (i > -1) {
                              list[i].quantity = Number(list[i].quantity || 0) + qty;
                            } else {
                              list.push({
                                productId: p.id,
                                Name: p.Name || '',
                                Price: unitPrice || 0,
                                quantity: qty,
                                imageUrl: p.imageUrl || '',
                                variationId: vid || '',
                                variationName: vName || ''
                              });
                            }

                            tx.update(orderRef, { cart: list });

                          case 10:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this6);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 24:

                _this6.$toast && _this6.$toast.success('تمت إضافة المنتج للطلبية');
                _this6.existingModal = false;

                _context5.next = 32;
                break;

              case 28:
                _context5.prev = 28;
                _context5.t0 = _context5['catch'](14);

                console.error(_context5.t0);
                _this6.existingError = 'تعذر الإضافة، حاول مجددًا';

              case 32:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[14, 28]]);
      }))();
    }
  }
});

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(736);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(729)("c7979c6a", content, true, {});

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(728)(true);
// imports


// module
exports.push([module.i, ".catalogContainer[data-v-2a506f7b]{padding:16px}.toolbar[data-v-2a506f7b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;-ms-flex-wrap:wrap;flex-wrap:wrap}.title h2[data-v-2a506f7b]{margin:0}.actions[data-v-2a506f7b]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.actions input[data-v-2a506f7b],.actions select[data-v-2a506f7b]{height:36px;padding:0 10px;border:1px solid #ddd;border-radius:10px}.hint[data-v-2a506f7b]{margin:8px 0 16px}.muted[data-v-2a506f7b]{color:#757575}.small[data-v-2a506f7b]{font-size:12px}.grid[data-v-2a506f7b]{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:14px}.card[data-v-2a506f7b]{background:#fff;border:1px solid #eee;border-radius:16px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.thumb[data-v-2a506f7b]{background-size:cover;background-position:50%;width:100%;padding-top:70%}.info[data-v-2a506f7b]{padding:10px 12px;display:grid;gap:6px}.name[data-v-2a506f7b]{font-weight:700}.price[data-v-2a506f7b]{font-weight:600}.vars select[data-v-2a506f7b]{width:100%;height:34px;border:1px solid #e5e5e5;border-radius:8px}.cta[data-v-2a506f7b]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;padding:10px 12px 12px;margin-top:auto}.cta button[data-v-2a506f7b]{-webkit-box-flex:1;-ms-flex:1;flex:1;height:38px;border:none;border-radius:10px;background:#111;color:#fff;cursor:pointer}.cta .secondary[data-v-2a506f7b]{background:#f5f5f5;color:#111}.loadMore[data-v-2a506f7b]{margin:16px 0}.loadingModal[data-v-2a506f7b],.loadMore[data-v-2a506f7b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.loadingModal[data-v-2a506f7b]{position:fixed;inset:0;background:hsla(0,0%,100%,.6);-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:30}.loader[data-v-2a506f7b]{width:36px;height:36px;border:4px solid #ccc;border-top-color:#111;border-radius:50%;-webkit-animation:spin-data-v-2a506f7b 1s linear infinite;animation:spin-data-v-2a506f7b 1s linear infinite}@-webkit-keyframes spin-data-v-2a506f7b{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-data-v-2a506f7b{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.modal[data-v-2a506f7b]{position:fixed;inset:0;background:rgba(0,0,0,.45);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:50}.modal-box[data-v-2a506f7b]{width:min(520px,95vw);background:#fff;border-radius:16px;overflow:hidden}.modal-head[data-v-2a506f7b]{padding:12px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #eee}.modal-body[data-v-2a506f7b]{padding:16px;display:grid;gap:8px}.modal-body input[data-v-2a506f7b]{height:38px;border:1px solid #ddd;border-radius:10px;padding:0 10px}.modal-foot[data-v-2a506f7b]{padding:12px 16px;border-top:1px solid #eee;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:8px}.modal-foot button[data-v-2a506f7b]{height:38px;border:none;border-radius:10px;background:#111;color:#fff;padding:0 16px;cursor:pointer}.close[data-v-2a506f7b]{background:transparent;border:none;font-size:20px;cursor:pointer}@media (max-width:640px){.actions[data-v-2a506f7b]{width:100%}.grid[data-v-2a506f7b]{grid-template-columns:repeat(2,1fr)}}", "", {"version":3,"sources":["D:/Projects/‏‏greenhousecakesTest/src/pages/CatalogPage.vue"],"names":[],"mappings":"AACA,mCAAoC,YAAc,CACjD,AACD,0BAA2B,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,yBAAyB,AAAC,sBAAsB,AAAC,mBAAmB,AAAC,yBAAyB,AAAC,sBAAsB,AAAC,8BAA8B,AAAC,SAAS,AAAC,mBAAmB,AAAC,cAAe,CACpR,AACD,2BAA4B,QAAS,CACpC,AACD,0BAA2B,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,QAAQ,AAAC,yBAAyB,AAAC,sBAAsB,AAAC,kBAAmB,CAC/J,AACD,iEAAmE,YAAY,AAAC,eAAe,AAAC,sBAAsB,AAAC,kBAAmB,CACzI,AACD,uBAAwB,iBAAkB,CACzC,AACD,wBAAyB,aAAc,CACtC,AACD,wBAAyB,cAAe,CACvC,AACD,uBAAwB,aAAa,AAAC,0DAA6D,AAAC,QAAS,CAC5G,AACD,uBAAwB,gBAAgB,AAAC,sBAAsB,AAAC,mBAAmB,AAAC,gBAAgB,AAAC,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,4BAA4B,AAAC,6BAA6B,AAAC,0BAA0B,AAAC,qBAAsB,CACxQ,AACD,wBAAyB,sBAAsB,AAAC,wBAA2B,AAAC,WAAW,AAAC,eAAgB,CACvG,AACD,uBAAwB,kBAAkB,AAAC,aAAa,AAAC,OAAQ,CAChE,AACD,uBAAwB,eAAgB,CACvC,AACD,wBAAyB,eAAgB,CACxC,AACD,8BAA+B,WAAW,AAAC,YAAY,AAAC,yBAAyB,AAAC,iBAAkB,CACnG,AACD,sBAAuB,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,QAAQ,AAAC,uBAAuB,AAAC,eAAgB,CAC/H,AACD,6BAA8B,mBAAmB,AAAC,WAAW,AAAC,OAAO,AAAC,YAAY,AAAC,YAAY,AAAC,mBAAmB,AAAC,gBAAgB,AAAC,WAAW,AAAC,cAAe,CAC/J,AACD,iCAAkC,mBAAmB,AAAC,UAAW,CAChE,AACD,2BAA2J,aAAc,CACxK,AACD,0DAF4B,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,wBAAwB,AAAC,qBAAqB,AAAC,sBAAuB,CAGzJ,AADD,+BAAgC,eAAe,AAAC,QAAQ,AAAC,8BAAiC,AAAyD,yBAAyB,AAAC,sBAAsB,AAAC,mBAAmB,AAAwE,UAAW,CACzS,AACD,yBAA0B,WAAW,AAAC,YAAY,AAAC,sBAAsB,AAAC,sBAAsB,AAAC,kBAAkB,AAAC,0DAA0D,AAAC,iDAAkD,CAChO,AACD,wCACA,GAAI,gCAAiC,AAAC,uBAAwB,CAC7D,CACA,AACD,gCACA,GAAI,gCAAiC,AAAC,uBAAwB,CAC7D,CACA,AAGD,wBAAyB,eAAe,AAAC,QAAQ,AAAC,2BAA4B,AAAC,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,yBAAyB,AAAC,sBAAsB,AAAC,mBAAmB,AAAC,wBAAwB,AAAC,qBAAqB,AAAC,uBAAuB,AAAC,UAAW,CAC7R,AACD,4BAA6B,sBAAuB,AAAC,gBAAgB,AAAC,mBAAmB,AAAC,eAAgB,CACzG,AACD,6BAA8B,kBAAkB,AAAC,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,yBAAyB,AAAC,sBAAsB,AAAC,8BAA8B,AAAC,yBAAyB,AAAC,sBAAsB,AAAC,mBAAmB,AAAC,4BAA6B,CAC1R,AACD,6BAA8B,aAAa,AAAC,aAAa,AAAC,OAAQ,CACjE,AACD,mCAAoC,YAAY,AAAC,sBAAsB,AAAC,mBAAmB,AAAC,cAAe,CAC1G,AACD,6BAA8B,kBAAkB,AAAC,0BAA0B,AAAC,oBAAoB,AAAC,oBAAoB,AAAC,aAAa,AAAC,qBAAqB,AAAC,kBAAkB,AAAC,yBAAyB,AAAC,OAAQ,CAC9M,AACD,oCAAqC,YAAY,AAAC,YAAY,AAAC,mBAAmB,AAAC,gBAAgB,AAAC,WAAW,AAAC,eAAe,AAAC,cAAe,CAC9I,AACD,wBAAyB,uBAAuB,AAAC,YAAY,AAAC,eAAe,AAAC,cAAe,CAC5F,AAGD,yBACA,0BAA2B,UAAW,CACrC,AACD,uBAAwB,mCAAsC,CAC7D,CACA","file":"CatalogPage.vue","sourcesContent":["\n.catalogContainer[data-v-2a506f7b]{ padding: 16px;\n}\n.toolbar[data-v-2a506f7b]{ display:-webkit-box; display:-ms-flexbox; display:flex; -webkit-box-align:center; -ms-flex-align:center; align-items:center; -webkit-box-pack:justify; -ms-flex-pack:justify; justify-content:space-between; gap:12px; -ms-flex-wrap:wrap; flex-wrap:wrap;\n}\n.title h2[data-v-2a506f7b]{ margin:0;\n}\n.actions[data-v-2a506f7b]{ display:-webkit-box; display:-ms-flexbox; display:flex; gap:8px; -webkit-box-align:center; -ms-flex-align:center; align-items:center;\n}\n.actions input[data-v-2a506f7b], .actions select[data-v-2a506f7b]{ height:36px; padding:0 10px; border:1px solid #ddd; border-radius:10px;\n}\n.hint[data-v-2a506f7b]{ margin:8px 0 16px;\n}\n.muted[data-v-2a506f7b]{ color:#757575;\n}\n.small[data-v-2a506f7b]{ font-size:12px;\n}\n.grid[data-v-2a506f7b]{ display:grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap:14px;\n}\n.card[data-v-2a506f7b]{ background:#fff; border:1px solid #eee; border-radius:16px; overflow:hidden; display:-webkit-box; display:-ms-flexbox; display:flex; -webkit-box-orient:vertical; -webkit-box-direction:normal; -ms-flex-direction:column; flex-direction:column;\n}\n.thumb[data-v-2a506f7b]{ background-size:cover; background-position:center; width:100%; padding-top:70%;\n}\n.info[data-v-2a506f7b]{ padding:10px 12px; display:grid; gap:6px;\n}\n.name[data-v-2a506f7b]{ font-weight:700;\n}\n.price[data-v-2a506f7b]{ font-weight:600;\n}\n.vars select[data-v-2a506f7b]{ width:100%; height:34px; border:1px solid #e5e5e5; border-radius:8px;\n}\n.cta[data-v-2a506f7b]{ display:-webkit-box; display:-ms-flexbox; display:flex; gap:8px; padding:10px 12px 12px; margin-top:auto;\n}\n.cta button[data-v-2a506f7b]{ -webkit-box-flex:1; -ms-flex:1; flex:1; height:38px; border:none; border-radius:10px; background:#111; color:#fff; cursor:pointer;\n}\n.cta .secondary[data-v-2a506f7b]{ background:#f5f5f5; color:#111;\n}\n.loadMore[data-v-2a506f7b]{ display:-webkit-box; display:-ms-flexbox; display:flex; -webkit-box-pack:center; -ms-flex-pack:center; justify-content:center; margin:16px 0;\n}\n.loadingModal[data-v-2a506f7b]{ position:fixed; inset:0; background:rgba(255,255,255,0.6); display:-webkit-box; display:-ms-flexbox; display:flex; -webkit-box-align:center; -ms-flex-align:center; align-items:center; -webkit-box-pack:center; -ms-flex-pack:center; justify-content:center; z-index:30;\n}\n.loader[data-v-2a506f7b]{ width:36px; height:36px; border:4px solid #ccc; border-top-color:#111; border-radius:50%; -webkit-animation:spin-data-v-2a506f7b 1s linear infinite; animation:spin-data-v-2a506f7b 1s linear infinite;\n}\n@-webkit-keyframes spin-data-v-2a506f7b{\nto{ -webkit-transform:rotate(360deg); transform:rotate(360deg)\n}\n}\n@keyframes spin-data-v-2a506f7b{\nto{ -webkit-transform:rotate(360deg); transform:rotate(360deg)\n}\n}\r\n\r\n/* مودال */\n.modal[data-v-2a506f7b]{ position:fixed; inset:0; background:rgba(0,0,0,0.45); display:-webkit-box; display:-ms-flexbox; display:flex; -webkit-box-align:center; -ms-flex-align:center; align-items:center; -webkit-box-pack:center; -ms-flex-pack:center; justify-content:center; z-index:50;\n}\n.modal-box[data-v-2a506f7b]{ width:min(520px, 95vw); background:#fff; border-radius:16px; overflow:hidden;\n}\n.modal-head[data-v-2a506f7b]{ padding:12px 16px; display:-webkit-box; display:-ms-flexbox; display:flex; -webkit-box-pack:justify; -ms-flex-pack:justify; justify-content:space-between; -webkit-box-align:center; -ms-flex-align:center; align-items:center; border-bottom:1px solid #eee;\n}\n.modal-body[data-v-2a506f7b]{ padding:16px; display:grid; gap:8px;\n}\n.modal-body input[data-v-2a506f7b]{ height:38px; border:1px solid #ddd; border-radius:10px; padding:0 10px;\n}\n.modal-foot[data-v-2a506f7b]{ padding:12px 16px; border-top:1px solid #eee; display:-webkit-box; display:-ms-flexbox; display:flex; -webkit-box-pack:end; -ms-flex-pack:end; justify-content:flex-end; gap:8px;\n}\n.modal-foot button[data-v-2a506f7b]{ height:38px; border:none; border-radius:10px; background:#111; color:#fff; padding:0 16px; cursor:pointer;\n}\n.close[data-v-2a506f7b]{ background:transparent; border:none; font-size:20px; cursor:pointer;\n}\r\n\r\n/* موبايل تحسينات بسيطة */\n@media (max-width: 640px){\n.actions[data-v-2a506f7b]{ width:100%;\n}\n.grid[data-v-2a506f7b]{ grid-template-columns: repeat(2, 1fr);\n}\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(515);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalogContainer"},[_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),(_vm.pageReady)?_c('small',{staticClass:"muted"},[_vm._v("/catalog/"+_vm._s(_vm.slug))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.search),expression:"search",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":"חיפוש מוצר..."},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value.trim()},_vm.debouncedReload],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sort.by),expression:"sort.by"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sort, "by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.reload()}]}},[_c('option',{attrs:{"value":"createdAt"}},[_vm._v("الأحدث")]),_vm._v(" "),_c('option',{attrs:{"value":"price"}},[_vm._v("السعر")]),_vm._v(" "),_c('option',{attrs:{"value":"name"}},[_vm._v("الاسم")]),_vm._v(" "),_c('option',{attrs:{"value":"orderedTimes"}},[_vm._v("الأكثر طلبًا")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sort.dir),expression:"sort.dir"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sort, "dir", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.reload()}]}},[_c('option',{attrs:{"value":"desc"}},[_vm._v("تنازلي")]),_vm._v(" "),_c('option',{attrs:{"value":"asc"}},[_vm._v("تصاعدي")])])])]),_vm._v(" "),(_vm.pageReady)?_c('div',{staticClass:"hint muted"},[_c('span',[_vm._v("מציג "+_vm._s(_vm.totalCountShown)+" מוצרים")]),_vm._v(" "),(_vm.activeFiltersText)?_c('span',[_vm._v(" • "+_vm._s(_vm.activeFiltersText))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid"},_vm._l((_vm.products),function(p){return _c('div',{key:p.id,staticClass:"card"},[_c('div',{staticClass:"thumb",style:({backgroundImage: ("url(" + (p.imageUrl || _vm.fallbackImg) + ")")})}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(p.Name))]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("₪ "+_vm._s(_vm.priceWithVar(p).toFixed(2)))]),_vm._v(" "),((p.variations && p.variations.length))?_c('div',{staticClass:"vars"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVar[p.id]),expression:"selectedVar[p.id]"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedVar, p.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("بدون متغير")]),_vm._v(" "),_vm._l((p.variations),function(v){return _c('option',{key:v.id,domProps:{"value":v.id}},[_vm._v(_vm._s(v.name))])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cta"},[_c('button',{on:{"click":function($event){return _vm.addToNewOrder(p)}}},[_vm._v("أضف لطلبية جديدة")]),_vm._v(" "),_c('button',{staticClass:"secondary",on:{"click":function($event){return _vm.openExistingModal(p)}}},[_vm._v("أضف لطلبية موجودة")])])])}),0),_vm._v(" "),(_vm.hasMore && !_vm.loading)?_c('div',{staticClass:"loadMore"},[_c('button',{on:{"click":function($event){return _vm.loadMore()}}},[_vm._v("تحميل المزيد")])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loadingModal"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),(_vm.existingModal)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"modal-head"},[_c('h3',[_vm._v("إضافة المنتج لطلبية موجودة")]),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":function($event){_vm.existingModal=false}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',[_vm._v("أدخل رقم الطلبية")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.existingOrderNumber),expression:"existingOrderNumber",modifiers:{"number":true}}],attrs:{"type":"number","placeholder":"مثال: 5978"},domProps:{"value":(_vm.existingOrderNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.existingOrderNumber=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',[_vm._v("الكمية")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.existingQty),expression:"existingQty",modifiers:{"number":true}}],attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.existingQty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.existingQty=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.existingError)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.existingError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-foot"},[_c('button',{on:{"click":function($event){return _vm.confirmAddToExisting()}}},[_vm._v("تأكيد الإضافة")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"muted small"},[_vm._v("سيتم البحث بحقل "),_c('b',[_vm._v("Orders.orderNumber")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.023181b56485b5475b5e.js